import g from '#core/global';
import load from '#core/load';


const media_duo_$ = '.media-duo';
const inner_$ = '.media-duo__inner';
const link_$ = '.media-duo__text-inner > ul > li > a';
const caret_$ = '.media-duo__caret';
const link_class = 'media-duo__text__link';
const link_span_class = 'media-duo__text__link__text';
const anchor_group_$ = '.anchor-group';
const anchor_items_$ = '.anchor-group__items';
const anchor_text_$ = '.anchor__text';
const compact_class = 'media-duo__anchor-group--compact';
const compact_grid_class = ':g-auto-3';
const compact_max_length = 12;

let has_media_duo = false;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('media-duo')) return false;
		
		load.content(() => {
			has_media_duo = assign_elements();
			if (!has_media_duo) return false;
		});
		load.all(() => {
			has_media_duo = assign_elements();
			if (!has_media_duo) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and enhance links
 * @return {boolean}
 */
function assign_elements() {
	if (has_media_duo) return true;
	
	const $media_duos = document.querySelectorAll(media_duo_$);
	if (!$media_duos.length) return false;
	
	$media_duos.forEach($media_duo => {
		enhance_links($media_duo);
		detect_compact_anchor_groups($media_duo);
	});
	
	return true;
}


/**
 * Enhance links with span wrapper and caret icon
 * @param {element} $media_duo
 */
function enhance_links($media_duo) {
	const $links = $media_duo.querySelectorAll(link_$);
	if (!$links.length) return false;
	
	const $inner = $media_duo.querySelector(inner_$);
	const $caret = $inner.querySelector(caret_$);
	if (!$caret) return false;
	
	$links.forEach($link => {
		const text_content = $link.textContent;
		const $span = document.createElement('span');
		$span.className = link_span_class;
		$span.textContent = text_content;
		
		$link.textContent = '';
		$link.appendChild($span);
		
		const $caret_clone = $caret.cloneNode(true);
		$link.appendChild($caret_clone);
		$link.classList.add(link_class);
	});
}


/**
 * Detect anchor groups with all-short text and add compact class
 * @param {element} $media_duo
 */
function detect_compact_anchor_groups($media_duo) {
	const $anchor_groups = $media_duo.querySelectorAll(anchor_group_$);
	if (!$anchor_groups.length) return false;

	$anchor_groups.forEach($anchor_group => {
		const $texts = $anchor_group.querySelectorAll(anchor_text_$);
		if (!$texts.length) return;

		const is_compact = Array.from($texts).every(
			$text => $text.textContent.trim().length <= compact_max_length
		);

		if (is_compact) {
			$anchor_group.classList.add(compact_class);
			const $items = $anchor_group.querySelector(anchor_items_$);
			if ($items) {
				$items.classList.add(compact_grid_class);
			}
		}
	});
}
